import { ManagedPropsLiteral } from "@made-people/managed-props";
import { Banner } from "../components/blueprint/banner/default-props";
import { LinkShortcuts } from "../components/blueprint/link-shortcuts/default-props";
import { CartItem } from "../components/blueprint/cart-item/default-props";
import { SuccessPage } from "../components/blueprint/success-page/default-props";
import {
  ProductTemplateAsVienna,
  SizePickerModal,
  StickyAddToCartButton,
} from "../components/blueprint/product/default-props";
import { ComponentWrapper } from "../components/blueprint/component-wrapper/default-props";
import { Filter } from "../components/blueprint/filter/default-props";
import { ProductList } from "../components/blueprint/product-list/default-props";
import { HeaderBarebone } from "../components/blueprint/header-desktop/default-props";
import { HeaderTemplate2 } from "../components/blueprint/header-mobile/default-props";
import { Swiper } from "../components/blueprint/swiper/default-props";
import { ReviewCardSwiperDefaults } from "../components/blueprint/swiper/review-card-swiper/default-props";
import { ReviewCard } from "../components/blueprint/review-card/default-props";
import { ImageAndText } from "../components/blueprint/image-and-text/default-props";
import { CardBannerDefaults } from "../components/blueprint/banner/card-banner/default-props";
import { FooterDefaults } from "../components/blueprint/footer/default-props";
import { Accordion } from "../components/blueprint/accordion/default-props";
import { AccordionAndText } from "../components/blueprint/accordion-and-text/default-props";
import { SelectBoxDefaults } from "../components/blueprint/form/select-box/default-props";

import { TopbarDefaults } from "../components/blueprint/topbar/default-props";
import {
  Foldout2MenuDefaults,
  MenuItemDefaults,
} from "../components/blueprint/menu-mobile/default-props";
import { Deck2MenuDefaults } from "../components/blueprint/menu-desktop/default-props";
import { LogosAndText } from "../components/blueprint/logos-and-text/default-props";
import { TextBlock } from "../components/blueprint/text-block/default-props";
import { SwipeableProductList } from "../components/blueprint/swipeable-product-list/default-props";
import {
  ProductCard,
  ProductCardQuickshopButtonGrid,
  QuickshopDrawer,
} from "../components/blueprint/product-card/default-props";
import { LinkAsLinkDefaults } from "../components/blueprint/link/default-props";
import { HeadingDefaults } from "../components/blueprint/heading/default-props";
import { ProductsDefaults } from "../components/blueprint/product-list/products/default-props";
import { ProductTemplateAsSalzburg } from "../components/blueprint/product/salzburg/default-props";
import { PageHeader } from "../components/blueprint/page-header/default-props";
import { LoadMore } from "../components/blueprint/load-more/default-props";
import { FeatureGroup } from "../components/blueprint/feature-group/default-props";
import { SearchAutocomplete } from "../components/blueprint/search/default-props";
import { Badge } from "../components/blueprint/badge/default-props";
import { MiniCart } from "../components/blueprint/mini-cart/default-props";
import { SearchSidebar } from "../components/blueprint/search-sidebar/default-props";
import { CartSummary } from "../components/blueprint/cart-summary/default-props";
import { MiniCartSwipeableProductListDefaults } from "../components/blueprint/swipeable-product-list/mini-cart-swipeable/default-props";
import { NewsletterSignup } from "../components/blueprint/newsletter-signup/default-props";

export const defaultProps: ManagedPropsLiteral = {
  NewsletterSignup,
  Banner,
  LinkShortcuts,
  CartItem,
  SuccessPage,
  ProductTemplateAsVienna,
  ComponentWrapper,
  Filter,
  SizePickerModal,
  StickyAddToCartButton,
  QuickshopDrawer,
  ProductCardQuickshopButtonGrid,
  ProductList,
  FeatureGroup,
  HeaderBarebone,
  HeaderTemplate2,
  Swiper,
  ReviewCardSwiper: ReviewCardSwiperDefaults,
  CardBanner: CardBannerDefaults,
  ReviewCard,
  SearchAutocomplete,
  ImageAndText,
  ProductCard,
  Badge,
  PageHeader,
  LoadMore,
  ProductTemplateAsSalzburg,
  MiniCart,
  Products: ProductsDefaults,
  MiniCartSwipeableProductList: MiniCartSwipeableProductListDefaults,
  Footer: FooterDefaults,
  SwipeableProductList,
  Accordion,
  AccordionAndText,
  SelectBox: SelectBoxDefaults,
  Topbar: TopbarDefaults,
  Foldout2Menu: Foldout2MenuDefaults,
  Deck2Menu: Deck2MenuDefaults,
  SearchSidebar,
  MenuItem: MenuItemDefaults,
  TextBlock,
  LinkAsLink: LinkAsLinkDefaults,
  Heading: HeadingDefaults,
  LogosAndText,
  CartSummary,
};
